<template>
  <div class="w-full space-y-4 px-8 text-white">
    <button
      v-if="fundingAdvisor"
      data-cy="funding-advisor-button"
      class="relative block h-14 w-full rounded-full bg-primary-heavy-contrast shadow-lg"
      @click="emit('click:funding-advisor')"
    >
      <div
        class="absolute top-1/2 left-2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-white/10"
      >
        <IconPhoneOutline />
      </div>
      <div>
        <div class="font-semibold">
          {{ $t("common.contactFundingAdvisor") }}
        </div>
        <div class="text-xs text-white/50">
          {{ `${fundingAdvisor.first_name} ${fundingAdvisor.last_name}` }}
        </div>
      </div>
    </button>
    <button
      v-if="hasChatSession"
      data-cy="ai-chat-button"
      class="relative block h-14 w-full rounded-full bg-primary-heavy-contrast shadow-lg"
      @click="emit('click:ai-chat')"
    >
      <div
        class="absolute top-1/2 left-2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-white/10"
      >
        <IconChat />
      </div>
      {{ $t("floatingButton.askAiInChat") }}
    </button>
  </div>
</template>

<script setup lang="ts">
import IconChat from "@/components/icons/IconChat.vue";
import IconPhoneOutline from "@/components/icons/IconPhoneOutline.vue";
import type { FundingAdvisor } from "@/api/http/schemas/applicationSchemas";

const { fundingAdvisor, hasChatSession } = defineProps<{
  fundingAdvisor?: FundingAdvisor | null;
  hasChatSession?: boolean;
}>();

const emit = defineEmits<{
  "click:funding-advisor": [];
  "click:ai-chat": [];
}>();
</script>
